import React, { useContext, ReactNode } from 'react';
import { Route } from 'react-router-dom';

import SubNavigation from 'components/SubNavigation/SubNavigation';
import Overall from './Overall';
import Streaming from './Streaming';
import Download from './Download';

import { performanceSubTopics } from 'topics';
import { IEntityPageComponentProps } from 'pages/Entity/shared';
import { EntityContext } from 'context/entityContext';
import TopicFilters from 'components/TopicFilters/TopicFilters';
import Playlist from './Playlist';

const Performance: React.FC<IEntityPageComponentProps> = (props) => {
  const { artistMetadata, match, pathPrefix } = props;
  const { entityId } = match.params;

  const { compareMode, topic } = useContext(EntityContext);

  return (
    <>
      <SubNavigation topic="performance" variants={performanceSubTopics} />
      <TopicFilters
        topic={topic[1] || topic[0]}
        compareMode={compareMode}
        entityType={'release'}
      />

      <Route
        exact
        path={`${pathPrefix}/release/${entityId}/performance/all`}
        render={(): ReactNode => <Overall />}
      />
      <Route
        exact
        path={`${pathPrefix}/release/${entityId}/performance/streaming`}
        render={(): ReactNode => <Streaming />}
      />
      <Route
        exact
        path={`${pathPrefix}/release/${entityId}/performance/download`}
        render={(): ReactNode => <Download />}
      />

      <Route
        exact
        path={`${pathPrefix}/release/${entityId}/performance/playlist`}
        render={(): ReactNode => (
          <Playlist
            artist={{
              entityType: artistMetadata?.type,
              entityId: artistMetadata?.id,
            }}
            topic="overview/view"
          />
        )}
      />
    </>
  );
};

export default Performance;
